import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import all from '../../assets/all.svg'
import biology from '../../assets/biology.svg'
import botany from '../../assets/botany.svg'
import chemistry from '../../assets/chemistry.svg'
import economics from '../../assets/economic.svg'
import geography from '../../assets/geography.svg'
import history from '../../assets/history.svg'
import mat from '../../assets/mat.svg'
import maths from '../../assets/maths.svg'
import physics from '../../assets/physics.svg'
import politicalScience from '../../assets/politicalScience.svg'
import zoology from '../../assets/zoology.svg'
import { UPDATE_CURRENT_LANGUAGE } from '../../constants/actionTypes'
import '../AnswerStatus/AnswerStatus.css'
import { selectLanguage } from '../Header/Header'
import './QuestionHeader.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { EVENT_NAMES } from 'constants/eventNames'
import { trackEvent } from 'utils/analyticsService'
import { ANALYTICS_KEYS } from 'constants/analytics-keys'

const mapStateToProps = (state) => ({
    current_question: state.current_question,
})
const mapDispatchToProps = (dispatch) => ({
    updateCurrentLanguage: (payload) => {
        dispatch({ type: UPDATE_CURRENT_LANGUAGE, payload })
    },
})
export const filterSubject = (sub) => {
    sub = sub.split(' ')
    sub = sub.map((item) => item.toLowerCase())
    sub = sub.map((item) => item.charAt(0).toUpperCase() + item.slice(1))
    return sub.join(' ')
}

const QuestionHeader = (props) => {
    const [isSticky, setSticky] = useState(false)
    const [dropdown, setDropdown] = useState(false)
    const [lngSupport, setLngSupport] = useState([])
    const { t, i18n } = useTranslation()
    const wrapperRef = useRef(null)
    const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setDropdown(false)
        }
    }
    useEffect(() => {
        document.addEventListener('mousedown', (e) => handleClickOutside(e))
        if (props.instruction) {
            const languageSupport = props.instruction?.language
            languageSupport && setLngSupport(languageSupport.split(','))
        }
        if (document.getElementById('sticky-tab')) {
            const sticky = document.getElementById('sticky-tab').offsetTop
            const handleScroll = window.addEventListener('scroll', () => {
                window.pageYOffset > sticky ? setSticky(true) : setSticky(false)
            })

            window.addEventListener('scroll', handleScroll)
            return () => {
                window.removeEventListener('scroll', () => handleScroll)
            }
        }
    }, [])
    const handleLangChange = (language) => {
        props.updateCurrentLanguage(language)
        i18n.changeLanguage(language)

        trackEvent(
            EVENT_NAMES.TAP_LANGUAGE_QUESTIONS_WEB,
            'User changes the language on the various question screens',
            {
                // success: true,
                [ANALYTICS_KEYS.LANGUAGE]: selectLanguage(language),
                [ANALYTICS_KEYS.EXTERNAL_ID]:
                    props.current_question?.question?.questionExternalId,
                [ANALYTICS_KEYS.SECTION_NAME]: props.current_question?.subject,
                [ANALYTICS_KEYS.QUESTION_ID]:
                    props.current_question?.question?.questionid,
                [ANALYTICS_KEYS.USER_TEST_ID]:
                    props.testStatus?.testStatus?.data?.userTestId,
            },
        )
        setDropdown(false)
    }
    const handleLangDropdownClick = () => {
        setDropdown(!dropdown)
    }
    return (
        <ul
            className={`tab-wrapper ${props.icon ? 'summary-header' : ''} ${
                isSticky ? ' sticky' : ''
            }`}
            id={props.icon ? '' : 'sticky-tab'}
        >
            <div
                // role="tablist"
                className={props.sectionType == 'submit' ? 'submit-tab' : 'subj-tab'}
                style={
                    props.location.pathname == '/submit'
                        ? { justifyContent: 'flex-start' }
                        : {}
                }
            >
                {props.header.map((data, index) => {
                    if (data.subject != 'All' && typeof data.subject == 'string')
                        data.subject = JSON.parse(data.subject)
                    if (data.subject == 'All')
                        data.subject = { en: 'All', hi: 'सभी', gu: 'તમામ' }
                    return props.icon ? (
                        <li
                            // role="tab"
                            className={
                                props.active === index
                                    ? 'tab-item active'
                                    : 'tab-item'
                            }
                            onClick={() => props.handleClick(index, data)}
                            id={index}
                            key={`{subject-${index}}`}
                        >
                            <div
                                className={`subject-icon ${
                                    data.subject.en.toLowerCase() == 'physics'
                                        ? 'physics'
                                        : data.subject.en.toLowerCase() ==
                                                'chemistry' ||
                                            data.subject.en.toLowerCase() ==
                                                'science'
                                          ? 'chemistry'
                                          : data.subject.en.toLowerCase() ==
                                              'mathematics'
                                            ? 'maths'
                                            : data.subject.en.toLowerCase() ==
                                                'biology'
                                              ? 'biology'
                                              : data.subject.en.toLowerCase() ==
                                                  'geography'
                                                ? 'geography'
                                                : data.subject.en.toLowerCase() ==
                                                    'history'
                                                  ? 'history'
                                                  : data.subject.en.toLowerCase() ==
                                                      'mental ability'
                                                    ? 'mat'
                                                    : data.subject.en.toLowerCase() ==
                                                        'political science'
                                                      ? 'politicalScience'
                                                      : data.subject.en.toLowerCase() ==
                                                          'zoology'
                                                        ? 'zoology'
                                                        : data.subject.en.toLowerCase() ==
                                                            'economics'
                                                          ? 'economics'
                                                          : data.subject.en.toLowerCase() ==
                                                              'botany'
                                                            ? 'botany'
                                                            : ''
                                }`}
                            >
                                <img
                                    src={
                                        data.subject.en.toLowerCase() == 'physics'
                                            ? physics
                                            : data.subject.en.toLowerCase() ==
                                                    'chemistry' ||
                                                data.subject.en.toLowerCase() ==
                                                    'science'
                                              ? chemistry
                                              : data.subject.en.toLowerCase() ==
                                                  'mathematics'
                                                ? maths
                                                : data.subject.en.toLowerCase() ==
                                                    'biology'
                                                  ? biology
                                                  : data.subject.en.toLowerCase() ==
                                                      'geography'
                                                    ? geography
                                                    : data.subject.en.toLowerCase() ==
                                                        'history'
                                                      ? history
                                                      : data.subject.en.toLowerCase() ==
                                                          'mental ability'
                                                        ? mat
                                                        : data.subject.en.toLowerCase() ==
                                                            'political science'
                                                          ? politicalScience
                                                          : data.subject.en.toLowerCase() ==
                                                              'zoology'
                                                            ? zoology
                                                            : data.subject.en.toLowerCase() ==
                                                                'economics'
                                                              ? economics
                                                              : data.subject.en.toLowerCase() ==
                                                                  'botany'
                                                                ? botany
                                                                : all
                                    }
                                />
                            </div>
                            {data.subject[i18n.language]}
                        </li>
                    ) : (
                        <li
                            // role="tab"
                            className={
                                props.active === index
                                    ? 'tab-item active'
                                    : 'tab-item'
                            }
                            onClick={() => props.handleClick(index, data)}
                            id={index}
                            key={`{subject-${index}}`}
                        >
                            {data.subject[i18n.language]}
                        </li>
                    )
                })}
            </div>
            {props.location.pathname !== '/submit' && lngSupport.length > 1 ? (
                <div className="dropdown-outer-wrapper">
                    <p className="dropdown-label">Test language</p>
                    <div
                        className={`dropdown-wrapper2 ${dropdown ? 'active' : ''}`}
                        value={i18n.language}
                        ref={wrapperRef}
                    >
                        <button
                            style={{ width: 'fit-content' }}
                            onClick={handleLangDropdownClick}
                        >
                            <span
                                className={`icon-drop`}
                                onClick={handleLangDropdownClick}
                            >
                                <span className="icon-drop">
                                    {dropdown ? (
                                        <FontAwesomeIcon icon={faChevronUp} />
                                    ) : (
                                        <FontAwesomeIcon icon={faChevronDown} />
                                    )}
                                </span>
                            </span>
                            {selectLanguage(i18n.language)}
                        </button>
                        <div className="icon-wrapper">
                            <div className="dropdown-content2">
                                <ul>
                                    {lngSupport.map((item, index) => {
                                        return (
                                            <li
                                                key={`${item}-${index}`}
                                                onClick={(e) =>
                                                    handleLangChange(item)
                                                }
                                            >
                                                <input
                                                    type="radio"
                                                    name="test"
                                                    id={index}
                                                    value={item}
                                                    checked={
                                                        i18n.language == item
                                                            ? 'checked'
                                                            : ''
                                                    }
                                                />
                                                <label htmlFor={index.toString()}>
                                                    {selectLanguage(item)}
                                                </label>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            ) : null}
        </ul>
    )
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(QuestionHeader),
)
